<template>
    <!-- ROOM ITEMS-->
    <v-sheet class="pt-8 pb-12">
        <v-slide-x-transition>
            <div v-show="isLoaded">
                <div
                    v-for="(roomItem, indexRoomItem) in roomItems"
                    :key="`room-item-${indexRoomItem}`"
                    :class="{ 'pt-8': indexRoomItem > 0 && roomItem.visible }"
                >
                    <v-list
                        v-if="roomItem.visible"
                        dense
                        class="material-list"
                    >
                        <v-list-group
                            :ripple="false"
                            :value="true"
                        >
                            <template v-slot:activator>
                                <v-list-item-title class="no-custom">
                                    <!-- ROOM ITEM MATERIALS -->
                                    <h2
                                        class="text-none font-weight-bold"
                                        :class="{'pb-2': !roomItem.description }"
                                        v-html="roomItem.name"
                                    />
                                    <v-subheader
                                        v-if="roomItem.description"
                                        v-text="roomItem.description"
                                        class="pt-2 habiteo-body-2 text-none"
                                    />
                                </v-list-item-title>
                            </template>

                            <RoomItem
                                v-for="(material, materialIndex) in roomItem.materials"
                                :key="`material-${materialIndex}`"
                                :material="material"
                                :materialIndex="materialIndex"
                                :roomItem="roomItem"
                                :roomItems="roomItems"
                                :harmonyMaterials="roomItem.type === 'harmony' ? getMaterialsFromCombination(material.combinations) : null"
                            />
                        </v-list-group> 
                    </v-list>
                    <!-- /ROOM ITEM MATERIALS -->
                </div>
            </div>
        </v-slide-x-transition>
    </v-sheet>
    <!-- ROOM ITEMS-->
</template>

<script>
    import RoomItem from '@/components/sidebar/configurableTour/components/RoomItem';
    import MaterialPreview from '@/components/sidebar/configurableTour/components/MaterialPreview';

    export default {
        name: 'RoomItems',
        props: {
            isLoaded: {
                type: Boolean,
                required: true
            },
            roomItems: {
                type: Array,
                required: true
            },
            materials: {
                type: Object,
                required: true
            }
        },
        components: {
            RoomItem,
            MaterialPreview
        },
        methods: {
            getMaterialsFromCombination(combinations) {
                let materialList = [];
                Object.keys(combinations).forEach(roomId => {
                    materialList.push({
                        'id': combinations[roomId],
                        'text': this.$props.materials[combinations[roomId]]
                    });
                });
                return materialList;
            }
        }
    }
</script>

<style lang="scss">
    .material {
        &-list {
            background-color: green;
            .v-list-group {
                .v-list-group__header {
                    .v-list-item__title {
                        color: #000000;
                    }
                    .v-list-item__icon {
                        i {
                            font-size: 24px !important;
                        }
                    }
                }
            }

            .v-subheader {
                padding: unset;
            }
            .v-list-item__title {
                overflow: unset;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/sidebar/configurableTour/components/RoomItems.vue